<template>
    <multiselect :class="classNames" v-bind="$props" v-model="valueInComponent" @open="onOpen" @select="onChange" @close="onClose" @remove="onRemove" :disabled="disabled">
        <template v-if="type === 'selection'" slot="selection" slot-scope="{ values, search, isOpen }">
            <feather-icon v-if="searchIcon" icon='SearchIcon' class="search-icon" />
            <span class="multiselect__single--selection text-md" v-if="values.length">
                <template v-if="values.length < childrenValues.length">
                    {{values.length}} {{$t('components.flexibleSelect.selected')}}
                </template>
                <template v-else-if="values.length === childrenValues.length">
                    {{$t('components.flexibleSelect.all')}}
                </template>
            </span>
        </template>

        <span v-if="noOptions" slot="noOptions" v-html="noOptions"></span>
        
        <!-- Add is all element for selected all with multiple option (beforeList slots) -->
        <div v-if="isHaveElementAll && multiple" slot="beforeList">
            <li @click="onSelectedAll" class="multiselect__element" :class="valueInComponent == '' ? 'select-all-option' : ''">
                <span data-select="Press enter to select" data-deselect="Press enter to remove" class="multiselect__option flex justify-between items-center">
                    <span>{{$t('global.all')}}</span>      
                    <feather-icon
                        v-if="valueInComponent == ''"
                        icon="CheckIcon"
                        svgClasses="w-6 h-6"
                    />              
                </span>
            </li>
        </div>

        <!-- Custom option selected -->
        <span v-if="isI18nTranslating" slot="singleLabel">{{$t(this.valueInComponent[this.label])}}</span>
        <!-- Custom options list displaying -->
        <template  slot="option" slot-scope="props">
            <div v-if="isI18nTranslating" class="option__desc flex justify-between items-center">
                <span class="option__title">{{ props.option.$groupLabel ? $t(props.option.$groupLabel) : $t(props.option[label]) }}</span>
                <feather-icon
                    v-if="isHaveIconcheck(props.option.$groupLabel ? props.option.$groupLabel : props.option[label])"
                    icon="CheckIcon"
                    svgClasses="w-6 h-6"
                />
            </div>
            <div v-else class="flex justify-between items-center">
                <span>{{ props.option.$groupLabel ? props.option.$groupLabel : props.option.name }}</span>
                <feather-icon
                    v-if="isHaveIconcheck(props.option.$groupLabel ? props.option.$groupLabel : props.option.value ? props.option.value : props.option.name)"
                    icon="CheckIcon"
                    svgClasses="w-6 h-6"
                />
            </div>
        </template> 

        <template v-if="showNoResults" slot="noResult">
            <span>{{ msgNoResults }}</span>
        </template>        
    </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    name: "flexible-select",

    components: {
        multiselect: Multiselect,
    },

    /**
     * $emit event in flexibleSelect
     * 
     * @event $emit onSelectedAll 
     */

    // Props extends the libraries
    // You can find documentation here: https://vue-multiselect.js.org/#sub-props
    props: [
        /**
         * borderBoth: { type: Boolean, default: true }
         */
        "cssBorderBold",

        "type", // "tag" | "selection"
        "multiselectMixin.js",
        "id",
        "options",
        "value",
        "multiple",
        "trackBy",
        "label",
        "searchable",
        "clearOnSelect",
        "hideSelected",
        "placeholder",
        "allowEmpty",
        "resetAfter",
        "closeOnSelect",
        "customLabel",
        "taggable",
        "tagPlaceholder",
        "tagPosition",
        "max",
        "optionsLimit",
        "groupValues",
        "groupLabel",
        "groupSelect",
        "blockKeys",
        "internalSearch",
        "preserveSearch",
        "preselectFirst",
        "Multiselect.vue",
        "name",
        "selectLabel",
        "selectGroupLabel",
        "selectedLabel",
        "deselectLabel",
        "deselectGroupLabel",
        "showLabels",
        "limit",
        "limitText",
        "loading",
        "disabled",
        "maxHeight",
        "openDirection",
        "showNoResults",
        "tabindex",
        "pointerMixin.js",
        "showPointer",
        "optionHeight",
        "Input",
        "Select",
        "Remove",
        "SearchChange",
        "Tag",
        "Open",
        "Close",
        "option",
        "maxElements",
        "noResult",
        "noOptions",
        "beforeList",
        "afterList",
        "caret",
        "singleLabel",
        "placeholder",
        "limit",
        "clear",
        "tag",
        "defaultValue",
        "isHaveElementAll",
        "searchIcon",

        /**
         * To called i18n change key string i18n in label
         * @returns {Boolean}
         */
        "isI18nTranslating",
        "msgNoResults"
    ],

    data: function() {
        return {
            classNames: {
                'multiselect--border-bold': this.cssBorderBold ? true : false,
                'multiselect--search-icon': this.searchIcon,
            },

            valueInComponent: this.defaultValue || "",
        }
    },

    watch: {
        valueInComponent() {
            this.$emit("input", this.valueInComponent);
        },

        /**
         * @description Listen change of select and set value for v-model value
         */
        defaultValue() {
            this.valueInComponent = this.defaultValue;
        }
    },

    computed: {
        childrenValues() {
            // Calculate to get all value in single options or group nested options

            if(this.groupLabel) {
                // Base on groupValues label to get value
                // After that, to flatten array 2 level
                const allValues = this.options.map((groupOption) => {
                    return groupOption[this.groupValues];
                }).flat(2);

                return allValues;
            }
            else {
                // Returns all options single option
                return this.options;
            }
        }
    },

    methods: {
        onChange() {
            this.$emit("change");
        },

        onClose() {
            this.$emit("close");
        },

        onSelectedAll() {
            this.$emit("onSelectedAll");
        },

        onOpen() {
            this.$emit("open");
        },

        onRemove({...props}) {
            this.$emit("remove", { ...props });
        },
        isHaveIconcheck(selected) {            
            let isHave = false;
            
            if (Array.isArray(this.valueInComponent)) {
                isHave =
                this.valueInComponent.find((value) => (this.isI18nTranslating ? value.name : value.value) == selected)                    
                    ? true
                    : false;                
            } else {                            
                isHave = this.valueInComponent && (this.isI18nTranslating || this.trackBy === 'name' ? this.valueInComponent.name : this.valueInComponent.value) == selected ? true : false;
            }

            return isHave;
        },
    },

    mounted() {
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect {
    .multiselect__select {
    }

    .select-all-option {
        background: var(--vs-hex-white);
        color: var(--vs-hex-primary);    
        .multiselect__option {
            font-weight: 600 !important;
        }
    }

    .multiselect__tags {
        min-height: 38px;
        // border-color: var(--vs-hex-gray);
        border-color: rgba($color: #000000, $alpha: 0.2);

        .multiselect__input {
            font-size: 14px;
            font-weight: 400;
            margin-bottom: 0px;
            transform: translateY(-2.5px);
            &::placeholder {
                color: var(--vs-hex-gray);
            }
        }

        .multiselect__single {
            padding-left: 7px;
            font-size: 14px;
            font-weight: 400;

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .multiselect__placeholder {
            color: #6e6b7b !important;
            font-size: 14px;
            font-weight: 400;
            padding-left: 7px;
            margin-bottom: 0;
            transform: translateY(-2.5px);
        }

        .multiselect__tags-wrap {
            .multiselect__tag {
                background: var(--vs-hex-primary);
                margin-bottom: 0;

                span {
                    cursor: default;
                    max-width: 80px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    display: inline-block;
                    padding-bottom: 1px;
                }

                .multiselect__tag-icon {
                    &::after {
                        color: var(--vs-hex-white);
                    }

                    &:hover {
                        background: transparent;
                    }
                }
            }
        }

        .multiselect__spinner {
            &::before,
            &::after {
                border-top-color: var(--vs-hex-primary);
            }
        }
    }

    &.multiselect--search-icon {
        .multiselect__tags {
            padding-left: 30px;
        }

        .search-icon {
            left: 13px; 
            top: 48%; 
            transform: translateY(-50%); 
            position: absolute !important; 
            width: 18px; 
            height: 18px; 
            color: #B9B9C3;
        }
    }

    .multiselect__content-wrapper {
        transform: translateY(8px);
        border-radius: 5px;
        z-index: 300;

        .multiselect__content {

            .multiselect__option {
                font-size: 14px;
                font-weight: 400;
            }

            .multiselect__element {
                font-size: 14px;
                font-weight: 400;
                .multiselect__option {
                    z-index: 300;

                    &.multiselect__option--highlight {
                        background: #f3f2f7;
                        color: #5e5873;

                        &::after {
                            background: var(--vs-hex-primary);
                            font-size: 9px;
                        }
                    }

                    &.multiselect__option--selected {
                        background: var(--vs-hex-white);
                        color: var(--vs-hex-primary);
                        font-weight: 600;   
                        &::after {
                            font-size: 9px;
                        }
                    }                   

                    &.multiselect__option--disabled {
                        background: var(--vs-hex-white);
                        color: #b9b9c3;
                    }

                    &.multiselect__option--group {
                        font-size: 14px;
                        font-weight: 600;
                        background: var(--vs-hex-white);
                        color: var(--vs-hex-gray);
                    }

                    &::after {
                        display: none;
                    }
                }
            }
        }
    }

    .multiselect__single--selection {
        padding-left: 15px;
        & ~ .multiselect__input {
            display: none !important;
        }
    }

    &.multiselect--active {
        z-index: 300;

        &:not(.multiselect--above) .multiselect__tags {
            border-radius: 5px;
        }

        .multiselect__tags {
            .multiselect__single--selection {
                display: none;
            }
            
            .multiselect__input {
                padding-left: 7px;
                padding-top: 2.5px;
                padding-bottom: 2.5px;

                display: block!important;
            }
        }
    }

    &.multiselect--border-bold {
        .multiselect__tags {
            border-color: var(--vs-hex-gray);
        }
    }
}

.dark-mode {
    .multiselect__select {
    }

    .multiselect__tags {
        border-color: var(--vs-hex-darkgray);
        background: var(--vs-hex-dm-dark);

        .multiselect__input {
            background: transparent;
            &::placeholder {
                color: var(--vs-hex-white);
            }
        }

        .multiselect__single {
            background: transparent;
        }

        .multiselect__placeholder {
        }

        .multiselect__tags-wrap {
            .multiselect__tag {
                span {
                }

                .multiselect__tag-icon {
                    &::after {
                    }

                    &:hover {
                    }
                }
            }
        }
    }

    .multiselect__content-wrapper {
        border-color: var(--vs-hex-dm-dark);

        .multiselect__content {

            .multiselect__option {
            }

            .multiselect__element {
                background: var(--vs-hex-dm-dark);

                .multiselect__option {
                    background: #283046;

                    &.multiselect__option--highlight {
                        background: #161D31 !important;

                        &::after {
                        }
                    }

                    &.multiselect__option--selected {   
                        background: #283046;                                         
                        span {
                            color: var(--vs-hex-primary)
                        }
                        &::after {
                        }
                    }

                    &.multiselect__option--disabled {
                        background: #283046;
                        color: #B9B9C3;
                    }

                    &.multiselect__option--group {
                    }

                    &::after {
                    }
                }
            }
        }
    }

    .multiselect__single--selection {
        padding-left: 15px;
        & ~ .multiselect__input {
            display: none !important;
        }
    }

    &.multiselect--active {

        &:not(.multiselect--above) .multiselect__tags {
        }

        .multiselect__tags {
            .multiselect__single--selection {
            }
            
            .multiselect__input {
               
            }
        }
    }

    &.multiselect--border-bold {
        .multiselect__tags {
            border-color: var(--vs-hex-gray);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Select/FlexibleSelect.vue